<template>
	<auth-layout
		title="亚太互联"
		subtitle="安全、高效的即时通讯平台"
		form-title="登录-Sign in"
		form-subtitle="欢迎回来，请登录您的账号"
	>
		<el-form
			class="auth-form"
			:model="loginForm"
			status-icon
			:rules="rules"
			ref="loginForm"
			@keyup.enter.native="submitForm('loginForm')"
		>
			<el-form-item prop="userName" v-show="false">
				<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item prop="userName">
				<el-input
					type="userName"
					v-model="loginForm.userName"
					autocomplete="off"
					:placeholder="loginNamePlaceholder"
					prefix-icon="el-icon-user"
					maxLength="11"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item prop="password">
				<el-input
					type="password"
					v-model="loginForm.password"
					autocomplete="off"
					placeholder="请输入密码"
					prefix-icon="el-icon-lock"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item prop="verifyCode">
				<div class="auth-captcha-row">
					<el-input
						v-model="loginForm.verifyCode"
						autocomplete="off"
						placeholder="请输入图形验证码"
						maxlength="6"
						clearable
						class="auth-captcha-row__input"
					></el-input>
					<div class="auth-captcha-row__img" @click="loadCaptchaImage" title="点击刷新">
						<img v-if="captchaImage" :src="captchaImage" class="auth-captcha-row__img-el" alt="验证码" />
						<span v-else class="auth-captcha-row__loading">加载中...</span>
					</div>
				</div>
			</el-form-item>
			<el-form-item>
				<div class="auth-actions auth-actions--stack">
					<el-button type="primary" :loading="loginLoading" @click="submitForm('loginForm')" size="large">登录</el-button>
					<el-button :disabled="loginLoading" @click="resetForm('loginForm')" size="large">清空</el-button>
				</div>
			</el-form-item>
		</el-form>
		<template #footer>
			<a :href="$store.state.configStore.app.downloadUrl" target="_blank" class="auth-download">
				<img src="@/assets/common/cdownload.png" alt="" />
				<span>App 下载</span>
			</a>
			<router-link to="/register" class="auth-link">没有账号？立即注册</router-link>
		</template>
	</auth-layout>
</template>

<script>
import AuthLayout from '@/components/common/AuthLayout.vue';

export default {
	name: 'login',
	components: {
		AuthLayout
	},
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		var checkVerifyCode = (rule, value, callback) => {
			if (!value || !value.trim()) {
				return callback(new Error('请输入图形验证码'));
			}
			callback();
		};
		return {
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: '',
				uuid: '',
				verifyCode: ''
			},
			captchaImage: '',
			loginLoading: false,
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				verifyCode: [{
					validator: checkVerifyCode,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		loadCaptchaImage() {
			this.$http({
				url: '/captcha/img/code',
				method: 'post'
			}).then((data) => {
				this.loginForm.uuid = data.id || data.uuid;
				this.captchaImage = data.image ? ('data:image/gif;base64,' + data.image) : '';
			}).catch(() => {
				this.$message.error('验证码加载失败');
			});
		},
		submitForm(formName) {
			if (this.loginLoading) return;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loginLoading = true;
					this.$http({
						url: '/login',
						method: 'post',
						data: this.loginForm
					})
						.then((data) => {
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							sessionStorage.setItem('accessToken', data.accessToken);
							sessionStorage.setItem('refreshToken', data.refreshToken);
							this.$message.success('登录成功');
							this.$router.push('/home/chat');
						})
						.catch(() => {
							this.loadCaptchaImage();
							this.loginForm.verifyCode = '';
						})
						.finally(() => {
							this.loginLoading = false;
						});
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.loadCaptchaImage();
		},
		getCookie(name) {
			let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
			let arr = document.cookie.match(reg);
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		setCookie(name, value) {
			document.cookie = name + '=' + escape(value);
		}
	},
	mounted() {
		this.loginForm.userName = this.getCookie('username');
		this.loginForm.password = this.getCookie('password');
		this.loadCaptchaImage();
	},
	computed: {
		loginNamePlaceholder() {
			let mode = this.$store.state.configStore.registration.mode;
			let strText = '用户名';
			if (mode.includes('phone')) {
				strText += '/手机号';
			}
			if (mode.includes('email')) {
				strText += '/邮箱';
			}
			return '请输入手机号';
		}
	}
};
</script>
